export default "__VITE_ASSET__DrK3zPLm__"